// remove specific html special characters from string
export function stripHtmlEscapeCharactersFromURL(url: string): string {
  const replaceMap = {
    '&amp;': '&',
  };
  return url.replace(/&amp;/g, (match) => replaceMap[match]);
}
